module.exports = "/_next/static/images/PowerfulIntegrations@2x-f0e374789e227f64176228d469cb1432.png";